import PricingTable from './PricingTable'
import PricingTableRow from './PricingTableRow'

export { PricingTable, PricingTableRow }
export default PricingTable
